declare const google: any;

let map;
export const initApplicationMap = async () => {
    const { Map } = await google.maps.importLibrary("maps");
    const { AdvancedMarkerElement } = await google.maps.importLibrary("marker");

    var mapElement = document.getElementById("map");
    if (typeof (mapElement) !== typeof (undefined) && mapElement != null) {
        let position = { lat: 51.46857943308016, lng: 3.9711608146296915 };

        map = new Map(document.getElementById("map"), {
            mapId: "e837881bc3874a19",
            center: position,
            zoom: 11,
        });

        let icon = document.createElement("img");
        icon.src = shopConfig().staticDomain + "/designimages/smulders/maps-marker.svg";
        icon.width = 50;
        icon.height = 50;

        var marker = new AdvancedMarkerElement({
            map,
            position: position,
            content: icon
        });
    }
};

(window as any).initApplicationMap = initApplicationMap;